import type { CSSProperties } from "react";

export const tooltipContentStyle: CSSProperties = {
  backgroundColor: "var(--card)",
  border: "1px solid var(--border)",
  borderRadius: "8px",
  fontSize: "12px",
};

export const tooltipItemStyle: CSSProperties = { color: "var(--foreground)" };

export const tooltipLabelStyle: CSSProperties = {
  color: "var(--muted-foreground)",
};

export const legendStyle: CSSProperties = {
  color: "var(--muted-foreground)",
};

export const formatKRW = (value?: number | string): string =>
  new Intl.NumberFormat("ko-KR").format(Number(value)) + "원";

const GROUP_THRESHOLD = 0.05;

export interface NameValue {
  name: string;
  value: number;
}

export interface DetailItem {
  name: string;
  value: number;
  percent: number;
  color: string;
  isGrouped: boolean;
}

export function groupSmallItems(items: NameValue[]): NameValue[] {
  const total = items.reduce((sum, item) => sum + item.value, 0);
  if (total === 0) return items;

  const major: NameValue[] = [];
  let etcValue = 0;

  for (const item of items) {
    if (item.value / total >= GROUP_THRESHOLD) {
      major.push(item);
    } else {
      etcValue += item.value;
    }
  }

  if (etcValue > 0) {
    major.push({ name: "기타", value: etcValue });
  }

  return major;
}

export const GROUPED_COLOR = "var(--chart-grouped)";

export function buildDetailList(
  items: NameValue[],
  colors: string[],
): DetailItem[] {
  const total = items.reduce((sum, it) => sum + it.value, 0);
  if (total === 0) return [];

  const majorNames = new Set(
    items
      .filter((it) => it.value / total >= GROUP_THRESHOLD)
      .map((it) => it.name),
  );

  let colorIndex = 0;
  const colorMap = new Map<string, string>();
  for (const item of items) {
    if (majorNames.has(item.name)) {
      colorMap.set(item.name, colors[colorIndex % colors.length]);
      colorIndex++;
    }
  }

  return items
    .map((it) => ({
      name: it.name,
      value: it.value,
      percent: (it.value / total) * 100,
      color: colorMap.get(it.name) ?? GROUPED_COLOR,
      isGrouped: !majorNames.has(it.name),
    }))
    .sort((a, b) => b.value - a.value);
}
